import React, { useState } from 'react';
import { Button, Container, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { fix_tomi7_pending_areas } from '../../utils/services';

function Legacy() {
  const token = localStorage.getItem('token');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [resultText, setResultText] = useState('');
  const [error, setError] = useState('');

  const formatResult = (data) => {
    if (data === null || data === undefined) {
      return '';
    }
    if (typeof data === 'string') {
      return data;
    }
    try {
      return JSON.stringify(data, null, 2);
    } catch {
      return String(data);
    }
  };

  const handleFixTomi7 = async () => {
    setLoading(true);
    setError('');
    setResultText('');

    try {
      const result = await fix_tomi7_pending_areas(token);

      if (result === 'INVALID') {
        navigate('/');
        return;
      }

      setResultText(formatResult(result));
    } catch (err) {
      setError(err?.message || 'Error al ejecutar la operación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-4">
      <h2 className="mb-4">Legacy</h2>

      <Button
        variant="primary"
        onClick={handleFixTomi7}
        disabled={loading}
        className="mb-3"
      >
        {loading ? 'Procesando…' : 'Generar areas a usuarios pendientes de TOMi7'}
      </Button>

      {error && <div className="text-danger mb-3">{error}</div>}

      <Form.Group>
        <Form.Label>Resultado</Form.Label>
        <Form.Control
          as="textarea"
          rows={20}
          readOnly
          value={resultText}
          placeholder="El resultado del llamado aparecerá aquí"
          style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
        />
      </Form.Group>
    </Container>
  );
}

export default Legacy;
